import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { startVersionCheck } from './utils/versionCheck';

const buildStamp = process.env.REACT_APP_BUILD_STAMP || 'dev';
window.__POKETTA_BUILD_STAMP__ = buildStamp;
startVersionCheck(buildStamp);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
